import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import {
  testGroupsViewColumns,
  mapTestGroupsViewQuery,
} from "./TestGroupsView.default";
import { getTestGroups } from "../../repository/data.repository";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";
import { createGridRequest } from "../../hooks/useGridRequest";
import { bundleScopedSearchSchema } from "../bundles/bundleFilters";

export interface TestGroupsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function TestGroupsView(props: TestGroupsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={testGroupsViewColumns}
      mapQuery={mapTestGroupsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getTestGroups, { retry: true })}
      pageSize={100}
      schema={bundleScopedSearchSchema}
      actions={(record) => [
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("Bundles", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Bundles", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default TestGroupsView;
